import { useState } from 'react'
import OrdersTable from './OrdersTable'
import UnsettledTable from './UnsettledTable'
import { useOrdersCount } from 'hooks/useOrdersCount'
import { useTranslation } from 'next-i18next'

type Tab = 'open' | 'unsettled'
const tabs: Tab[] = ['open', 'unsettled']

const OrdersTabs = ({ onClick }: { onClick?: () => void }) => {
  const { t } = useTranslation('orders')
  const [activeTab, setActiveTab] = useState<Tab>('open')
  const { openOrdersCount, unsettledCount } = useOrdersCount()
  return (
    <div>
      <div className="mb-3 flex gap-5">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`font-bold focus:outline-none md:hover:text-th-active ${
              activeTab === tab ? 'text-th-active' : 'text-th-fgd-3'
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {t(`tabs.${tab}`)}
            {tab === 'open' && openOrdersCount > 0 ? (
              <span className="ml-1 text-xs">({openOrdersCount})</span>
            ) : null}
            {tab === 'unsettled' && unsettledCount > 0 ? (
              <span className="ml-1 text-xs">({unsettledCount})</span>
            ) : null}
          </button>
        ))}
      </div>
      {activeTab === 'open' && <OrdersTable onClick={onClick} />}
      {activeTab === 'unsettled' && <UnsettledTable />}
    </div>
  )
}

export default OrdersTabs
